import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function masters() {
  const response = await http.getData("/ceklist-alteplase/masters").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data) {
  const response = await http.postData("/ceklist-alteplase", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/ceklist-alteplase/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/ceklist-alteplase`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/ceklist-alteplase/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function print(id) {
  window.open(`${http.getAPI()}/ceklist-alteplase/${id}/pdf`, "_blank");
}

export default {
  masters,
  create,
  update,
  getByRegister,
  destroy,
  print
};
